const Fiverr = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 508.02 508.02">
      <defs></defs>
      <circle style={{ fill: "#1dbf73" }} cx="254.01" cy="254.01" r="254.01" />
      <circle style={{ fill: "#fff" }} cx="315.97" cy="162.19" r="26.87" />
      <path
        style={{ fill: "#fff" }}
        d="M345.87,207.66h-123V199.6c0-15.83,15.83-16.13,23.89-16.13,9.25,0,13.44.9,13.44.9v-43.6a155.21,155.21,0,0,0-19.71-1.19c-25.68,0-73.16,7.16-73.16,61.51V208h-22.4v40.31h22.4v85.1h-20.9v40.31H247.34V333.37H222.85v-85.1H290v85.1H269.13v40.31h97.65V333.37H345.87Z"
        transform="translate(-1.83 -0.98)"
      />
    </svg>
  );
};

export default Fiverr;
